'use client'

import { memo } from 'react'
import {
  Breadcrumbs,
  type BreadcrumbItemType,
  useBreadcrumbs
} from '../PageBreadcrumbs'
import {
  type ContentTypeKey,
  getContentTypeName
} from '@/constants/breadcrumbs'

type NewtBreadcrumbsProps = {
  contentType: ContentTypeKey
  title: string
  className?: string
}

/**
 * Newtの記事用のパンくずリストコンポーネント
 */
export const NewtBreadcrumbs = memo(
  ({ contentType, title, className = '' }: NewtBreadcrumbsProps) => {
    // 基本のパンくずアイテムを取得
    const defaultItems = useBreadcrumbs()

    // Newtコンテンツタイプに応じたタイトルを作成
    let items: BreadcrumbItemType[] = []

    // コンテンツタイプに対応するセクションURLとセクション名
    const sectionUrl = `/${contentType}`
    // 定義済みセクション名から取得
    const sectionName = getContentTypeName(contentType)

    // パンくずリストを構築:
    // 1. ホームへのリンク (デフォルトの最初のアイテム)
    // 2. セクションへのリンク (例: /column)
    // 3. 現在の記事タイトル (リンクなし)
    items = [
      // ホーム
      defaultItems[0],
      // セクション
      {
        name: sectionName,
        url: sectionUrl
      },
      // 記事タイトル
      {
        name: title,
        isLast: true
      }
    ]

    return <Breadcrumbs items={items} className={className} />
  }
)

NewtBreadcrumbs.displayName = 'NewtBreadcrumbs'
